import React, { useState, useRef, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { useHistory } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import {
  combineImage,
  itterateArray,
  renderMultipleImagePreviews,
} from "../../util/fn";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { toast } from "react-toastify";
import { API } from "../../constant/api";

export default function SendOffer({ id, setTabIndex }) {
  // const { id } = props.match.params;
  const form = useForm();

  const { register, handleSubmit, setValue, errors, watch } = useForm();

  const history = useHistory();
  const { fields, append, remove } = useFieldArray({
    control: form.control,
  });

  const [open, setOpen] = useState(false);
  const [image, setImage] = useState({});
  const [removeImages, setRemoveImages] = useState({});
  const [price, setPrice] = useState(0);
  const [userDetails, setUserDetails] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isSpecialOffer, setIsSpecialOffer] = useState(false);
  const fileInputRef = useRef();
  const { response, request } = useRequest();
  const { request: sendOfferReq, response: sendOfferRes } = useRequest();

  useEffect(() => {
    request("GET", `orders/item/${id}`);
  }, []);

  useEffect(() => {
    if (response) {
      setUserDetails(response?.orderOffer);
      console.log("response :", response);
      if (response?.orderOffer.length > 0) {
        response?.orderOffer.map((val, index) => {
          setValue(`items.${index}.price`, val.orderOffer.price);
          setValue(
            `items.${index}.isPartGenuine`,
            val.orderOffer.isPartGenuine
          );
          setValue(
            `items.${index}.isPartAvailable`,
            val.orderOffer.isPartAvailable
          );
          setValue(`items.${index}.notes`, val.orderOffer.notes);
          setValue(`items.${index}.shipmentnotes`, val.orderOffer.shipmentnotes);
          setImage((pre) => ({
            ...pre,
            [val._id]: val.orderOffer.images,
          }));
          // setValue(`items.${index}.price`, val.orderOffer.price);
        });
      }
      let priceData = response?.orderOffer.reduce((acc, val) => {
        const currentPrice = parseFloat(val.orderOffer.price) || 0;
        return acc + currentPrice;
      }, 0);
      setTotalPrice(priceData);
      // setTotalPrice(
      //   item.length > 0
      //     ? item.reduce((acc, val) => {
      //         const currentPrice = parseFloat(val.price) || 0;
      //         return acc + currentPrice;
      //       }, 0)
      //     : 0
      // );
    }
  }, [response]);

  useEffect(() => {
    if (sendOfferRes) {
      console.log("sendOfferRes :", sendOfferRes);
      if (sendOfferRes.status) {
        toast.success(sendOfferRes?.message);
        history.push(`/orders/view/${id}`);
        setTabIndex(0)
      }
    }
  }, [sendOfferRes]);
  function handlePriceChange(event) {
    const newPrice = event.target.value;
    setPrice(newPrice);
  }
  function handleChange(event, oderData) {
    const index = oderData._id;
    // do something with event data
    const newFiles = event.target.files;
    const imageFiles = Array.from(newFiles).filter((file) =>
      file.type.startsWith("image/")
    );

    let uploadFiles = Object.assign({}, image);
    if (!uploadFiles[index]) {
      uploadFiles[index] = [];
    }
    uploadFiles[index] = [...uploadFiles[index], ...imageFiles];
    setImage(uploadFiles); // Update state with new files
  }

  const onSubmit = (data) => {
    const [images, imageIndex] = combineImage(image);

    const sendOfferFilter = data?.items.filter((item) => item.price);

    if (sendOfferFilter.length < 1) {
      toast.error("Please enter at least one item before submitting.");
      return;
    }

    const sendOfferData = sendOfferFilter.map((item) => {
      let imageArr = imageIndex[item.itemId];
      let removeImagesData = removeImages[item.itemId];

      if (imageArr) {
        let imgIndex =
          imageArr.start_index == imageArr.end_index
            ? [imageArr.end_index]
            : [imageArr.start_index, imageArr.end_index];

        let imagesindexes =
          itterateArray(imgIndex)?.length > 0
            ? { imageIndex: itterateArray(imgIndex) }
            : {};
        return {
          ...item,
          ...imagesindexes,
          // imageIndex: itterateArray(imgIndex),
          removeImages: removeImagesData,
        };
      } else {
        return item;
      }
    });

    const formData = new FormData();
    images.forEach((element) => {
      if (element !== undefined) {
        formData.append("images", element);
      }
    });
    formData.append("sendOffer", JSON.stringify(sendOfferData));
    formData.append("orderId", id);
    formData.append("isSpecialOffer", isSpecialOffer);
    formData.append("specialDiscount", data?.specialOffer || 0);
    sendOfferReq("POST", "order-offer", formData);
  };

  const handleRemoveImage = (index, id, file) => {
    const updatedFiles = [...image[id]];
    updatedFiles.splice(index, 1); // Remove the image at the specified index
    setImage((prevFiles) => ({ ...prevFiles, [id]: updatedFiles }));
    if (typeof file == "string" && file.startsWith("uploads")) {
      const removeFile = Object.assign({}, removeImages);
      if (removeFile[id]) {
        removeFile[id].push(file);
      } else {
        removeFile[id] = [file];
      }

      setRemoveImages(removeFile);
    }
  };

  useEffect(() => {
    let item = form.getValues("items") || [];

    setTotalPrice(
      item.length > 0
        ? item.reduce((acc, val) => {
            const currentPrice = parseFloat(val.price) || 0;
            return acc + currentPrice;
          }, 0)
        : 0
    );
  }, [price]);
  const handleFileClick = (index) => {
    document.getElementById(`partsFileRef.${index}`).click();
  };

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid ere"
      id="kt_content"
    >
      <Breadcrumb
        title="View Order"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/orders", name: "Back To Orders" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className="container" id="">
          <div className="row">
            <div className="col-12">
              <div className="card card-custom card-stretch card-shadowless mt-5">
                <div className="card-header ">
                  <div class="card-title py-5">
                    <h3 class="card-label">
                      <span class="d-block text-dark font-weight-bolder">
                        {" "}
                        Send Offer
                      </span>
                    </h3>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row justify-content-center-" role="">
                    <div className="col-md-8">
                      <div className="card- card-custom gutter-b">
                        <div className="">
                          <div>
                            <form onSubmit={form.handleSubmit(onSubmit)}>
                              <div class="accordion" id="accordionExample">
                                {userDetails.length > 0
                                  ? userDetails.map((val, index) => (
                                      <div
                                        key={val._id}
                                        className="card mb-3"
                                        id={`heading-${index}`}
                                      >
                                        {form.setValue(
                                          `items.${index}.itemId`,
                                          val._id
                                        )}
                                        <div className="card-header">
                                          <button
                                            className="btn btn-link rowInBtn"
                                            type="button"
                                            data-toggle="collapse"
                                            data-target={`#collapse-${index}`}
                                            aria-expanded="false"
                                            aria-controls={`collapse-${index}`}
                                            onClick={() =>
                                              setOpen((prev) => !prev)
                                            }
                                          >
                                            <span>
                                              <span>
                                                {val?.orderOffer?.name}
                                              </span>
                                            </span>

                                            <a className="float-right">
                                              <i
                                                className={`fa ${
                                                  open
                                                    ? "fa-angle-up a-1x"
                                                    : "fa-angle-down a-1x"
                                                }`}
                                              ></i>
                                            </a>
                                          </button>
                                        </div>
                                        <div
                                          id={`collapse-${index}`}
                                          // className="collapse"
                                          aria-labelledby={`heading-${index}`}
                                          data-parent="#accordionExample"
                                          className={`collapse ${
                                            index == 0 ? "show" : ""
                                          }`}
                                        >
                                          <div className="card-body">
                                            <div className="mt-2">
                                              <div className="">
                                                <div className="mb-4">
                                                  <div className=" d-flex align-items-center justify-content-between inputAfterBorder">
                                                    <p className="partInfoLabel">
                                                      Price:{" "}
                                                    </p>
                                                    <input
                                                      type="text"
                                                      className="price-input form-control w-50"
                                                      name={`items.${index}.price`}
                                                      defaultValue={
                                                        val.orderOffer.price
                                                      }
                                                      {...form.register(
                                                        `items.${index}.price`,
                                                        {
                                                          validate: (value) => {
                                                            // Check if value is a number using isNaN
                                                            if (isNaN(value)) {
                                                              return "Price must be a number";
                                                            }

                                                            // Check if value is an integer using remainder after division by 1
                                                            if (
                                                              value % 1 !==
                                                              0
                                                            ) {
                                                              return "Price must be a positive integer";
                                                            }

                                                            // Check if value is positive (greater than or equal to 0)
                                                            if (value < 0) {
                                                              return "Price must be a positive number";
                                                            }

                                                            // All conditions passed, return true (no error message)
                                                            return true;
                                                          },
                                                          onChange:
                                                            handlePriceChange,
                                                        }
                                                      )}
                                                    />
                                                  </div>
                                                  {form.formState.errors
                                                    ?.items?.[index]?.price && (
                                                    <span className="invalid-feedback">
                                                      {
                                                        form.formState.errors
                                                          ?.items?.[index]
                                                          ?.price?.message
                                                      }
                                                    </span>
                                                  )}
                                                </div>
                                                <div className="mb-4 d-flex align-items-center justify-content-between inputAfterBorder">
                                                  <p className="partInfoLabel">
                                                    is the part genuine:{" "}
                                                  </p>
                                                  <input
                                                    type="checkbox"
                                                    data-toggle="toggle"
                                                    data-style="ios"
                                                    name={`items.${index}.isPartGenuine`}
                                                    defaultChecked={
                                                      val.orderOffer
                                                        .isPartGenuine
                                                    }
                                                    {...form.register(
                                                      `items.${index}.isPartGenuine`
                                                    )}
                                                  />
                                                </div>
                                                <div className="mb-4 d-flex align-items-center justify-content-between inputAfterBorder">
                                                  <p className="partInfoLabel">
                                                    Available{" "}
                                                  </p>
                                                  <input
                                                    type="checkbox"
                                                    data-toggle="toggle"
                                                    data-style="ios"
                                                    name={`items.${index}.isPartAvailable`}
                                                    defaultChecked={
                                                      val.orderOffer
                                                        .isPartAvailable
                                                    }
                                                    {...form.register(
                                                      `items.${index}.isPartAvailable`
                                                    )}
                                                  />
                                                </div>
                                                <div className="mb-4 d-flex align-items-center justify-content-between inputAfterBorder">
                                                  <p className="partInfoLabel">
                                                    Note{" "}
                                                    <span>
                                                      (If Not Genuine)
                                                    </span>{" "}
                                                  </p>
                                                  <textarea
                                                    rows={2}
                                                    className="form-control w-50"
                                                    name={`items.${index}.notes`}
                                                    defaultValue={
                                                      val.orderOffer.notes
                                                    }
                                                    {...form.register(
                                                      `items.${index}.notes`
                                                    )}
                                                  />
                                                </div>

                                                <div className="mb-4 d-flex align-items-center justify-content-between inputAfterBorder">
                                                  <p className="partInfoLabel">
                                                    Note{" "}
                                                    <span>
                                                      (For Price,Shipment etc.)
                                                    </span>{" "}
                                                  </p>
                                                  <textarea
                                                    rows={2}
                                                    className="form-control w-50"
                                                    name={`items.${index}.shipmentnotes`}
                                                    defaultValue={
                                                      val.orderOffer.shipmentnotes
                                                    }
                                                    {...form.register(
                                                      `items.${index}.shipmentnotes`
                                                    )}
                                                  />
                                                </div>

                                                <div className="uploadFileInPopup">
                                                  {image[val._id]?.length >
                                                  0 ? (
                                                    <div>
                                                      {renderMultipleImagePreviews(
                                                        image,
                                                        val._id,
                                                        handleRemoveImage
                                                      )}
                                                    </div>
                                                  ) : null}
                                                  <div
                                                    onClick={() =>
                                                      // fileInputRef.current.click()
                                                      handleFileClick(val._id)
                                                    }
                                                  >
                                                    <img src="/assets/img/upload_icon.png" />
                                                    <p>Upload Parts Photo</p>
                                                  </div>
                                                  <input
                                                    // onChange={(event) =>
                                                    //   handleChange(
                                                    //     event,
                                                    //     val._id,
                                                    //     index
                                                    //   )
                                                    // }
                                                    id={`partsFileRef.${val._id}`}
                                                    onChange={(event) =>
                                                      handleChange(event, val)
                                                    }
                                                    multiple={true}
                                                    ref={fileInputRef}
                                                    type="file"
                                                    hidden
                                                  />
                                                </div>

                                                {/* {val.orderOffer?.images
                                                  ?.length > 0 &&
                                                  val.orderOffer.images.map(
                                                    (value) => {
                                                      return (
                                                        <img
                                                          src={`${API.PORT}/${value}`}
                                                          width="150px"
                                                        />
                                                      );
                                                    }
                                                  )} */}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  : null}
                              </div>
                            </form>
                          </div>
                        </div>
                        <div className="px-5- d-flex align-item-center justify-content-between  mt-5">
                          <label htmlFor="is-special_offer" className="mb-0">
                            Do you want to show Special Offers to Customer
                          </label>
                          <input
                            type="checkbox"
                            data-toggle="toggle"
                            data-style="ios"
                            id="is-special_offer"
                            name={`isSpecialOffer`}
                            checked={isSpecialOffer}
                            onChange={(e) =>
                              setIsSpecialOffer(e.target.checked)
                            }
                            // defaultChecked={val.orderOffer.isSpecialOffer}
                          />
                        </div>
                        {isSpecialOffer ? (
                          <div className="mb-4">
                            <div className="d-flex align-items-center justify-content-between inputAfterBorder">
                              <p className="partInfoLabel">Special Offer(%): </p>
                              <input
                                type="text"
                                className="price-input form-control w-50"
                                name={`specialOffer`}
                                {...form.register(`specialOffer`, {
                                  validate: (value) => {
                                    if (!isSpecialOffer) {
                                      return true; // No validation needed if isSpecialOffer is false
                                    }

                                    if (isNaN(value)) {
                                      return "Special Offer must be a number";
                                    }

                                    if (value % 1 !== 0) {
                                      return "Special Offer must be a positive integer";
                                    }

                                    if (value < 0) {
                                      return "Special Offer must be a positive number";
                                    }

                                    if (value === "0") {
                                      return "Special Offer cannot be 0%";
                                    }

                                    if (value > 99) {
                                      return "A special offer must be less than 100%.";
                                    }

                                    return true; // All conditions passed
                                  },
                                })}
                              />
                            </div>
                            {form.formState.errors?.specialOffer && (
                              <span className="invalid-feedback">
                                {form.formState.errors?.specialOffer?.message}
                              </span>
                            )}
                          </div>
                        ) : null}

                        <div className="px-5- d-flex justify-content-between mt-5">
                          <p>Total</p>
                          <h4>SAR {totalPrice}</h4>
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={form.handleSubmit(onSubmit)}
                        >
                          Send Offer
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
